export const MainNav = [
  {
    icon: 'pe-7s-note2',
    label: 'DASHBOARD',
    to: '/dashboard',
  },
  {
    icon: 'pe-7s-news-paper',
    label: 'New Bulletin',
    to: '/bulletin',
  },
  {
    icon: 'pe-7s-graph2',
    label: 'ALL JOBS',
    to: '/jobs',
  },
  {
    icon: 'pe-7s-users',
    label: 'EMPLOYEE',
    to: '/technicians',
  },
  {
    icon: 'pe-7s-user',
    label: 'CUSTOMER',
    to: '/customers',
  },
  {
    icon: 'pe-7s-tools',
    label: 'NEW EQUIPMENT',
    to: '/new-equipment',
  },
  {
    icon: 'pe-7s-plane',
    label: 'NEW INSTALLATION',
    to: '/new-installation',
  },
  {
    icon: 'pe-7s-hourglass',
    label: 'C.O.E',
    to: '/change-of-equipment',
  },
  {
    icon: 'pe-7s-car',
    label: 'NEW RELOCATION',
    to: '/new-relocation',
  },
  {
    icon: 'pe-7s-trash',
    label: 'NEW REMOVAL',
    to: '/new-removal',
  },
  {
    icon: 'pe-7s-tools',
    label: 'SERVICES',
    to: '/services',
  },
  {
    icon: 'pe-7s-look',
    label: 'WATCH AND ACT',
    to: '/watch-act',
  },
  {
    icon: 'pe-7s-display2',
    label: 'MEMO',
    to: '/memo',
  },
  {
    icon: 'pe-7s-chat',
    label: 'SMS TEMPLATE',
    to: '/sms-template',
  },
  {
    icon: 'pe-7s-mail',
    label: 'EMAIL TEMPLATE',
    to: '/email-template',
  },
  {
    icon: 'pe-7s-speaker',
    label: 'Viper + Ad',
    to: '/viper-ads',
  },

];
